import { configureStore, ThunkDispatch, UnknownAction } from "@reduxjs/toolkit";
import { persistReducer, persistStore } from "redux-persist";
import { EnvConfig } from "../constants/EnvConfig";
import { defaultState } from "./alert/reducer";
import { defaultBuilding } from "./buildings/reducer";
import { defaultCycle } from "./cycle/reducer";
import { effectsDefaultState } from "./effects/reducer";
import { audioDefaultState } from "./music/reducer";
import { defaultQuestState } from "./quests/reducer";
import { initialRates } from "./rates/reducer";
import { rootReducer } from "./RootReducer";
import { initialScouts } from "./scout/reducer";
import { userDefaultSettings } from "./settings/reducer";
import storage from "./sync-storage";
import { tourDefaultState } from "./tour/reducer";
import { userInfo, userToken } from "./user/reducer";
import { initialAnnouncementState } from "./announcements/reducer";
import { initialEventState } from "./events/reducer";
import { initialChatState } from "../modules/chat/store/chatSlice";
import mapModeReducer from "./mapMode/reducer";

// config
const persistConfig = {
  key: "root",
  storage: storage,
  whitelist: [
    "userToken",
    "userInfo",
    "userSettings",
    "buildings",
    "tour",
    "myScouts",
    "currentCycle",
    "quests",
    "announcements",
    "mapMode",
  ],
  blacklist: [
    "alert",
    "messages",
    "usersMetaData",
    "audioPlayable",
    "effects",
    "rates",
    "activeChat",
    "arenaDialog",
    "chats",
    "events",
  ],
};

//combine
const persistedReducer = persistReducer(persistConfig, rootReducer);

//state values
const initState: any = {
  userToken,
  userInfo,
  userSettings: userDefaultSettings,
  alert: defaultState,
  rates: initialRates,
  chats: initialChatState,
  audioPlayable: audioDefaultState,
  tour: tourDefaultState,
  quests: defaultQuestState,
  myScouts: initialScouts,
  buildings: defaultBuilding,
  currentCycle: defaultCycle,
  effects: effectsDefaultState,
  announcements: initialAnnouncementState,
  events: initialEventState,
  mapMode: { isMapMode: true },
};

export const myStore = configureStore({
  reducer: persistedReducer,
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: false,
      // {
      //   ignoredActions: ["persist/PERSIST"],
      //   ignoredPaths: ["chats"],
      // },
    }),
  preloadedState: initState,
  devTools: EnvConfig.MODE === "development",
});

export const persistor = persistStore(myStore);

export type RootState = ReturnType<typeof rootReducer>;

export type AppDispatch = ThunkDispatch<string, any, UnknownAction>;

// Export myStore as default for easier imports in service files
export default myStore;
